
const extract = (original) => {
    // example:
    //   "raven:ReadRavens" -> ["read", "ravens"]

    let normalized = normalize(original);
    return normalized
            .replace(/^[^:]+:/, '')     // remove domain prefix
            .replace(/([A-Z])/g, '_$1') // insert _ before capitals
            .replace(/^_/, '')          // drop leading _
            .toLowerCase()
            .split(/_(.+)/);
}

const normalize = (original) => {
    const list = {
        "raven:TripShare": "raven:ShareTrip",
        "raven:DriverMessaging": "raven:SendDriverMessage",
        "raven:ReadRavens": "raven:ReadSelf",
        "raven:WriteRavens": "raven:WriteSelf",
        "tag:ReadTags": "tag:ReadSelf",
        "tag:WriteTags": "tag:WriteSelf",
    };
    
    return list[original] || original;
}

export default {
    order: 0, // default order
    apply: (permissionsMap = {}, grantedPermissions = [], context = {}) => {
        const out = { ...permissionsMap };

        grantedPermissions.forEach(p => {
            const [action, resource] = extract(p);
            if (action && resource) {
                if (!out[resource]) {
                    out[resource] = {};
                }
                out[resource][action] = true;
            }
        });

        return out;
    }
}